import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BrandXXS } from '#src/atoms/typography/index.tsx';
import { isType } from '#src/lib/gql/index.ts';
import { getRewardImage } from '#src/lib/rewards.tsx';

import type { RewardIcon_AnyRewardInterface } from './__generated__/index.graphql.ts';

const Wrapper = styled(Horizontal).attrs({
  gap: 0.5,
})`
  display: inline-flex;
  vertical-align: middle;
  img {
    max-width: var(--double-unit);
    max-height: var(--double-unit);
  }
`;

type Props = {
  reward: RewardIcon_AnyRewardInterface;
};
export const RewardIcon = ({ reward }: Props) => {
  const imgReward = getRewardImage(reward);
  return (
    <Wrapper>
      {!!imgReward && <img src={imgReward} alt="" />}
      {isType(reward, 'CardShardsReward') && (
        <BrandXXS color="var(--c-nd-1000)">{reward.quantity}</BrandXXS>
      )}
      {isType(reward, 'InGameCurrencyReward') && !!reward.config?.amount && (
        <>
          x<BrandXXS color="var(--c-nd-1000)">{reward.config.amount}</BrandXXS>
        </>
      )}
    </Wrapper>
  );
};

RewardIcon.fragments = {
  AnyRewardInterface: gql`
    fragment RewardIcon_AnyRewardInterface on AnyRewardInterface {
      id
      ...getRewardImage_anyRewardInterface
      ... on CardShardsReward {
        id
        quantity
      }
      ... on InGameCurrencyReward {
        id
        config {
          id
          amount
        }
      }
    }
    ${getRewardImage.fragments.anyRewardInterface}
  ` as TypedDocumentNode<RewardIcon_AnyRewardInterface>,
};
